import script from "./UnlockChallengeCta.vue?vue&type=script&setup=true&lang=js"
export * from "./UnlockChallengeCta.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__